const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`80ee6d547c52c0fc62f5ad0ad1433362d55d6f1d6a7155ec9e31547ebafb379b`, `80ee6d547c52c0fc62f5ad0ad1433362d55d6f1d6a7155ec9e31547ebafb379b`, 1, 3), new Map([[`comment`, (context.has(`comment`) ? context.get(`comment`) : null)], [`logged_in_user`, (context.has(`logged_in_user`) ? context.get(`logged_in_user`) : null)], [`allow_replies`, (context.has(`allow_replies`) ? context.get(`allow_replies`) : null)]]), true, false, 1));
            }

            getTemplateName() {
                return `80ee6d547c52c0fc62f5ad0ad1433362d55d6f1d6a7155ec9e31547ebafb379b`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `80ee6d547c52c0fc62f5ad0ad1433362d55d6f1d6a7155ec9e31547ebafb379b`, ``);
            }
        }],
        [3, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/comment/comment.twig`, `80ee6d547c52c0fc62f5ad0ad1433362d55d6f1d6a7155ec9e31547ebafb379b`, 1);

                this.blocks = new Map([
                    ['author_title', [this, 'block_author_title']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/comment/comment.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_author_title(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.traceableDisplayParentBlock(7, this.source)(`author_title`, context, blocks);
                this.echo(`
    <span class="u-hidden-visually">(Article</span>
    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/badge/badge.twig`, new Map([[`label`, `Author`], [`icon`, `pencil`]]), false, false, 9));
                this.echo(`  `);
            }

            getTemplateName() {
                return `80ee6d547c52c0fc62f5ad0ad1433362d55d6f1d6a7155ec9e31547ebafb379b`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `80ee6d547c52c0fc62f5ad0ad1433362d55d6f1d6a7155ec9e31547ebafb379b`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '80ee6d547c52c0fc62f5ad0ad1433362d55d6f1d6a7155ec9e31547ebafb379b');

let template = env.loadTemplate('80ee6d547c52c0fc62f5ad0ad1433362d55d6f1d6a7155ec9e31547ebafb379b');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/comment/demo/author.twig", args: context }
     );
     return rendered;;
};